module.exports = __WEBPACK_EXTERNAL_MODULE_84__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/observable/of","commonjs2":"rxjs/add/observable/of","amd":"rxjs/add/observable/of"}
// module id = 84
// module chunks = 0 1